import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { InlineIcon } from '../../../../../inline-icon/inline-icon';
import LinkCopiedIcon from '../../../../../../icons/compiled/components/LinkCopiedIcon';
import styles from './styles.scss';
export const LinkCopied = ({ dataHook, shouldShowLink, text, isRTL }) => (React.createElement("div", { className: classNames(styles['link-container'], {
        [styles['link-fade-in']]: shouldShowLink,
    }), "aria-hidden": "true", tabIndex: "-1", "data-hook": dataHook },
    React.createElement(InlineIcon, { className: classNames(styles.icon, {
            [styles.rtl]: isRTL,
            [styles.ltr]: !isRTL,
        }), icon: React.createElement(LinkCopiedIcon, null) }),
    React.createElement("div", { "data-hook": "link-copied-text" }, text)));
LinkCopied.propTypes = {
    dataHook: PropTypes.string,
    shouldShowLink: PropTypes.bool,
    text: PropTypes.string,
    isRTL: PropTypes.bool,
};
//# sourceMappingURL=link-copied.js.map